










































































import { UseTabs } from "@/common/composition/use-tabs";
import { SharedState } from "@/common/state";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import Vue from "vue";
export default Vue.extend({
  components: { SimpleNavTabs },
  props: ["title", "playbook_desc", "actions", "configure_cta_text"],
  setup(_, { emit }) {
    const [tabs, selected_tab, set_selected_tab] = UseTabs(
      [
        {
          id: "playbook",
          name: "Playbook",
        },
        /*  {
          id: "trend",
          name: "Trend",
        }, */
      ],
      0
    );

    const show_playbook = () => {
      if (SharedState.is_biz_user.value) {
        SharedState.restrictions.show_restrictions_modal("role", "Playbooks");
        return;
      }
      emit("playbook");
    };

    return { tabs, selected_tab, set_selected_tab, show_playbook };
  },
});
